import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Overview from './components/Overview';
import About from './components/About';
import Projects from './components/Projects';
import Services from './components/Services';
import OurTeam from './components/OurTeam';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Overview />
        <About />
        <Projects />
        <Services />
        <OurTeam />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;